import * as React from "react";
import { InputProps } from "./form";
import {
    FormControl,
    FormHelperText,
    Select as MuiSelect,
    InputLabel,
} from "@mui/material";
import { Controller } from "react-hook-form";

interface Props extends InputProps {
    label: React.ReactNode;
    children: React.ReactNode;
    multiple?: boolean;
    fullWidth?: boolean;
}

export const Select = React.forwardRef(
    (p: Props, _ref: React.Ref<HTMLDivElement>) => {
        const labelId = React.useId();
        const defaultValue = React.useMemo(
            () => (p.multiple ? [] : ""), // see https://mui.com/api/select/#props value
            [p.multiple]
        );

        return (
            <Controller
                name={p.name}
                control={p.control}
                render={({ field }) => (
                    <FormControl
                        required={p.required}
                        fullWidth={p.fullWidth}
                        error={p.error}
                    >
                        <InputLabel id={labelId}>{p.label}</InputLabel>
                        <MuiSelect
                            label={p.label}
                            labelId={labelId}
                            multiple={p.multiple}
                            value={field.value || defaultValue}
                            onChange={field.onChange}
                        >
                            {p.children}
                        </MuiSelect>
                        <FormHelperText error={p.error}>
                            {p.helperText}
                        </FormHelperText>
                    </FormControl>
                )}
            />
        );
    }
);
